// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2tPkf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__13wf6"};